import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-designation-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './designation-table.component.html',
  styleUrls: ['./designation-table.component.css']
})
export class DesignationTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showAddEditModal = false;
  showDeleteModal = false;
  isEditMode = false;
  showSkeleton = true;

  designationForm: FormGroup;
  @Input() designations: any[] = [];
  @Input() departments: any[] = [];
  @Input() loading = false;
  @Input() orgDetail: any[] = [];
  @Output() addDesignation = new EventEmitter<any>();
  @Output() editDesignation = new EventEmitter<{ id: any; data: any }>();
  @Output() deleteDesignation = new EventEmitter<any>();
  @Input() showSkeletonTrigger = false;

  selectedDesignationId: number | null = null;

  constructor(private fb: FormBuilder) {
    this.designationForm = this.fb.group({
      des_name: ['', Validators.required],
      des_description: ['', Validators.required],
      orgnazation: [null, Validators.required]
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['showSkeletonTrigger'] && changes['showSkeletonTrigger'].currentValue) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

  showTableLoader(duration = 800) {
    this.showSkeleton = true;
    const DEFAULT_ROWS = 5;
    // const rowCount = this.designations?.length || 2;
    const rowCount = (this.designations && this.designations.length) ? this.designations.length : DEFAULT_ROWS;;
    const columnCount = 3; 
    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }

  // Toggle Add/Edit or Delete modals
  toggleModal(type: 'add' | 'delete') {
    if (type === 'add') {
      this.showAddEditModal = !this.showAddEditModal;
      if (!this.showAddEditModal) {
        this.isEditMode = false;
        this.selectedDesignationId = null;
        this.designationForm.reset();
      }
    } else if (type === 'delete') {
      this.showDeleteModal = !this.showDeleteModal;
    }
  }

  openEditModal(item: any) {
    this.isEditMode = true;
    this.showAddEditModal = true;
    this.selectedDesignationId = item.id;

    const selectedOrg = this.orgDetail.find(
      (org: any) => org.name === item.organization_name
    );

    this.designationForm.patchValue({
      des_name: item.designation_name,
      des_description: item.description,
      orgnazation: selectedOrg || null
    });
  }

  openDeleteModal(item: any) {
    this.selectedDesignationId = item.id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.selectedDesignationId !== null) {
      this.deleteDesignation.emit(this.selectedDesignationId);
      this.toggleModal('delete');
      this.selectedDesignationId = null;
    }
  }

  onSave() {
    if (this.designationForm.invalid) return;

    const formValue = this.designationForm.value;
    if (this.isEditMode && this.selectedDesignationId !== null) {
      this.editDesignation.emit({ id: this.selectedDesignationId, data: formValue });
    } else {
      this.addDesignation.emit(formValue);
    }
    this.toggleModal('add');
  }
}
